<template>
  <div>
    <form>
      <div class="form-group">
        <label for="username">Username</label>
        <router-link :to="{ name: 'get-create-username-link' }" class="create-username">Need to create a username?</router-link>
        <input
          type="text"
          v-validate="'required'"
          name="username"
          :class="{
            input: true,
            'is-danger': errors.has('username'),
            'is-success': !errors.has('username')
          }"
          class="form-control form-control-lg"
          v-model="userCredentials.username"
          placeholder="Enter username"
          id="username"
          required
        />
        <span v-show="errors.has('username')" class="text-danger">Username is required</span>
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          v-validate="'required|min:8'"
          name="password"
          :class="{
            input: true,
            'is-danger': errors.has('password'),
            'is-success': !errors.has('password')
          }"
          class="form-control form-control-lg"
          v-model="userCredentials.password"
          placeholder="Enter password"
          id="password"
          required
          autocomplete="off"
        />
        <span v-show="errors.has('password')" class="text-danger">{{ errors.first("password") }}</span>
      </div>
      <div class="form-group mt-21">
        <button type="submit" class="btn btn-primary btn-block" :disabled="apiCallInProgress" v-on:click.prevent="loginUser">
          Sign In
        </button>
      </div>
    </form>
    <div class="footer-links forgot-links">
      <router-link :to="{ name: 'forgot-password-via-username' }">Forgot Password</router-link>
      <router-link :to="{ name: 'forgot-username' }">Forgot Username</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "awsLogin",
  data() {
    return {
      userCredentials: {
        username: "",
        password: ""
      },
      apiCallInProgress: false
    };
  },
  computed: {
    ...mapGetters(["multiFactorAuthEnabled"])
  },
  methods: {
    ...mapActions(["awsCognitoLogin", "setmultiFactorEnableFlag"]),
    async loginUser() {
      const regExForSpaces = /\s/g;
      if (!this.errors.any() && this.userCredentials.username.trim() != "" && this.userCredentials.password != "") {
        if (regExForSpaces.test(this.userCredentials.username.trim())) {
          this.$toastr.error("Username not found.");
        } else {
          nprogress.start();
          this.apiCallInProgress = true;
          this.userCredentials.username = this.userCredentials.username.trim();
          try {
            const userResponse = await this.awsCognitoLogin(this.userCredentials);
            if (userResponse && userResponse.next === "TwoFARequest") {
              this.setmultiFactorEnableFlag(true);
              this.$emit("goToMFAScreen", userResponse);
            }
            nprogress.done();
          } catch (error) {
            nprogress.done();
            this.apiCallInProgress = false;
            this.$toastr.error(error.message);
          }
        }
      } else if (!this.userCredentials.username && !this.userCredentials.password) {
        this.$toastr.error("Please enter your credentials.");
      } else if (!this.userCredentials.username || this.userCredentials.username.trim() == "") {
        this.$toastr.error("Username is required");
      } else if (!this.userCredentials.password || this.userCredentials.password == "") {
        this.$toastr.error("Please provide your password, it is required");
      }
    }
  }
};
</script>
